<style scoped>
    @import url("../../styles/smartControl/agendSC.scss");
</style>

<template>
    <div class="box_agendSC">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-database-clock-outline</v-icon>
            <span class="ml-2">Agendamentos externos</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema">
            <!--<TimeLineAgend :key="execSys" :execSys="execSys" :emailCliente="emailCliente" />-->
            <HandleAgend :key="execSys" :execSys="execSys" :emailCliente="emailCliente" />
        </div>

    </div>
</template>

<script>
//import TimeLineAgend from './timeLineAgend/TimeLineAgend'
import HandleAgend from './AgendCreate/HandleAgend'

export default {

    components:{
        HandleAgend
        //TimeLineAgend
    },

    data() {
        return {
            //
            //r:'/dadoslipordia',

            // loading
            flagLoading:true,

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
        }
    },

    methods:{

        initTableBySys() {

            // -- obter sistema atual selecionado.
            this.execSys = this.$store.state.sistemaSC

            // -- se sistema vazio, então não buscar o sistema...
            if (this.execSys == '') { this.flagMsgSistema = true; this.flagLoading = false; return; } 
            else { this.flagMsgSistema = false }

            // -- obter nome cliente logado (email).
            this.emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            // -- requisitar dados pipeline exec.
            //(feito direto no componente filho passando cliente e sistema acima)

            // -- habilitar exibição da tabela exec.
            this.flagLoading = false // -- desabilitar loading.
            this.flagTable = true // -- habilitar exibição tabela pipeline exec. (todas as versoes)
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 

            if (execSys != 'aveleda1') { 
                this.flagMsgSistema = false
                this.initTableBySys() 
            } // nao ha dados recentes para o POC 2023
            else { 
                this.msgSistema = 'Agendamento indisponível para este sistema'
                this.flagLoading = false // -- desabilitar loading.
                this.flagMsgSistema = true
            } 
        }
    }
}
</script>